export const axiosHelper = {
    handleResponse
};

function handleResponse (response) {
    const data = response.data;

    if (!response.statusText == 'OK' || (data && data.Status == 'Error')) {
        const error = (data && data.Message) || response.statusText;
        return Promise.reject(error);
    }

    return data;
}
